export const iconFontAwesomeMoneyChartPie = (
	<i className="fa-solid fa-chart-pie"></i>
);
